//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	
	props: {
		ranges: Object,
		prices: Object,
		type: String,
		measureTitle: String
	},

	computed: {

		messages()
		{
			return (Object.freeze({
				CT_BCE_CATALOG_RANGE_FROM: BX.message('CT_BCE_CATALOG_RANGE_FROM'),
				CT_BCE_CATALOG_RANGE_TO: BX.message('CT_BCE_CATALOG_RANGE_TO')
			}));
		},
	},

	mounted()
	{
		$(this.$refs.link).popover({
			html: true,
			placement: 'bottom',
			content: this.$refs.popup,
			trigger: 'hover',
			boundary: 'window'
		});
	}
}
